import { useAuthStore } from '@dashboard/stores/authStore'
import { createSharedComposable, useLocalStorage } from '@vueuse/core'
import { storeToRefs } from 'pinia'

// The layout calls this before the user has loaded, so the key must follow the user.
export const useSidebarCollapse = createSharedComposable(() => {
  const { user } = storeToRefs(useAuthStore())
  const userCollapsed = useLocalStorage<boolean>(() => `rm_sidebar_collapsed_${user.value?.id ?? 'guest'}`, false)

  const toggle = () => {
    userCollapsed.value = !userCollapsed.value
  }

  return { userCollapsed, toggle }
})
